/* eslint-disable array-bracket-newline */
import { useEffect, useState } from 'react';
import { ITicker } from '@kattana-io/common';
import eventEmitter from '../../core/eventEmitter';
import { getLiveTradesEventName } from '../../helpers/events-builder';
import { subscription } from '../../store/createStore';
import { useSelector } from 'react-redux';
import { IStore } from '../../reducers/index';
import { getPrice } from '../Modal/TickersModal/helper';
import useTicker from '../../hooks/useTicker';

const getBasePrice = (ticker: ITicker): string => {
  const { price, price_usd, quoteIsStablecoin } = useTicker(ticker);
  if (price_usd) {
    return `$${price_usd.toFixed(2)}`;
  }
  if (quoteIsStablecoin) {
    return `$${price.toFixed(2)}`;
  } // if quote is USD                         // 1 WETH = ... KTN (not USD price)
  return ''; // do not show if we don't have any price
};

const useTickerLivePrice = (ticker: ITicker) => {
  const { flipped, exchange, name, chain } = ticker;
  const [base, quote] = name.split('/');
  const [price, setPrice] = useState(getBasePrice(ticker));
  const [side, setSide] = useState<'buy' | 'sell'>();
  const rates = useSelector((store: IStore) => store.rates.items);

  useEffect(() => {
    const eventName = getLiveTradesEventName(chain, base, quote);
    subscription.subscribeToLiveTrades(eventName, ticker);
    setPrice(getBasePrice(ticker));

    const lastPriceChangeHandler = (message: any) => {
      const { trade } = message;
      if (trade) {
        if (ticker.flipped && trade.priceb_usd != 0) {
          setSide(trade.buy === 1 ? 'sell' : 'buy');
          setPrice(`$${parseFloat(trade.priceb_usd).toFixed(2)}`);
        } else if (!ticker.flipped && trade.pricea_usd != 0) {
          setSide(trade.buy === 1 ? 'buy' : 'sell');
          setPrice(`$${parseFloat(trade.pricea_usd).toFixed(2)}`);
        } else {
          const priceUSD = getPrice(ticker, rates);
          setPrice(priceUSD);
        }
      }
    };

    eventEmitter.on(eventName, lastPriceChangeHandler);

    return () => {
      eventEmitter.removeListener(eventName, lastPriceChangeHandler);
      subscription.unsubscribeFromLiveTrades(eventName);
    };
  }, [exchange, base, quote, ticker, rates, flipped, chain]);

  return { price, side, base, quote, exchange };
};

export default useTickerLivePrice;
